export class MiscImageModel {
	public ECommerceNo: string | null | undefined;
	public ImageCount: number;
	public Src: string;
}
